// extracted by mini-css-extract-plugin
export var backdropBlur = "_jj-0";
export var contentCard = "_jj-5";
export var frame = "_jj-2";
export var image = "_jj-4";
export var imagePane = "_jj-3";
export var modal = "_jj-1";